export default [
    {
        path: '/bargain/index',
        component: (resolve) => require(['@/components/bargain/Index'], resolve),
        meta: {
            title: '砍价列表',
            loginIn: true,
        }
    },

    {
        path: '/bargain/Details',
        component: (resolve) => require(['@/components/bargain/Details'], resolve),
        meta: {
            title: '砍价详情',
            default: '/bargain/index',
            multiple: true,
            loginIn: true,
            exclude: 'pageBack'
        }
    },
    {
        path: '/bargain/order',
        component: (resolve) => require(['@/components/bargain/Order'], resolve),
        meta: {
            title: '支付页面',
            default: '/bargain/Details',   //默认返回
            multiple: true,     //是否为多入口页面
            loginIn: true,
            // exclude: 'pageBack' //不允许返回
        }
    },
    {
        path: '/bargain/history',
        component: (resolve) => require(['@/components/bargain/History'], resolve),
        meta: {
            title: '砍价历史',
            loginIn: true,
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/bargain.js